function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M240.961,228.622c-5.886,0-11.187,4.531-12.605,10.774l-0.018,21.234c1.506,6.174,6.576,10.309,12.623,10.309 c9.786,0,15.399-7.778,15.399-21.34C256.36,244.68,255.25,228.622,240.961,228.622z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "117.776,238.902 135.305,238.902 126.256,207.463  "
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.057,0L35.14,54.272l-0.031,342.279l0.031,0.003v28.099h298.486v-0.38l0.924,0.086l54.993-42.067V0H72.057z  M150.698,297.559l-9.359-31.139h-29.475l-8.64,31.139h-35.83l39.219-128.313h41.167l39.789,128.313H150.698z M277.692,286.576 c-7.979,8.359-18.724,12.963-30.251,12.963c-9.762,0-17.941-3.107-24.069-9.072l-0.625,7.092h-29.249l0.045-134.795h34.359v45.275 c6.101-4.868,14.18-7.476,23.498-7.476c10.31,0,19.504,3.77,26.588,10.901c8.659,8.716,13.372,21.886,13.271,37.082 C291.26,264.118,286.568,277.277,277.692,286.576z M359.543,367.469l-25.917,19.825V54.272H71.592L87.993,30h271.55V367.469 L359.543,367.469z"
}));

const SvgDictionary = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "424.652px",
    height: "424.652px",
    viewBox: "0 0 424.652 424.652",
    style: {
      enableBackground: "new 0 0 424.652 424.652"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDictionary, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dictionary.c6137179.svg";
export { ForwardRef as ReactComponent };